<script>
  import { createEventDispatcher } from 'svelte';
  import Modal from '@components/Modal.svelte';

  const dispatch = createEventDispatcher();

  export let showModal = false;
  export let options = [];
  export let title = 'MENU';
  export let fadeInDuration = 200;
  export let showBackButton = false;
  export let slideIn;
  export let goBack;
  export let contentClass;

  let hideOptions = function () {
    showModal = false;
    dispatch('close');
  };

  let refresh = function () {
    options = options;
  };
</script>

<style style="text/scss" lang="scss">
  .options-container {
    display: flex;
    flex-direction: column;
    margin-bottom: -10px;

    .container-option {
      display: flex;
      align-items: center;
      padding: 15px;
      cursor: pointer;
      border-radius: 15px;
      padding-top: 12px;
      padding-bottom: 12px;

      &:hover {
        background: #f5f3fc;
      }

      .container-option-image {
        margin-right: 24px;

        :global(img) {
          height: 24px;
          width: 24px;
        }
      }

      .container-option-name {
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
      }
    }
  }

  .menu-lbl {
    font-weight: bold;
    font-size: 12px;
    line-height: 15px;
    color: #1a1a1a;
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    margin-top: 10px;
  }
</style>

{#if showModal}
  <div class="svelte-modal">
    <Modal
      mobile={true}
      on:close={() => {
        window.localStorage.removeItem('lastMobileMenuItem');
        showModal = false;
      }}
      show={showModal}
      modalLocation="bottom"
      fadeInDuration={fadeInDuration}
      slideIn={slideIn}
      class={$$props.class}
      closeButtonStyle="position: absolute; top: 18px; right: 20px; padding: 0px;"
      closeButtonSize={'large'}
      style="border-radius: 15px; width: 550px;">
      <div slot="header">
        <div class="ui-modal-header">
          {#if showBackButton}
            <div class="ui-modal-header-back" on:click={() => goBack()}>
              <img src="/images/switch-accounts-modal/back-black.svg" alt="back-button" />
            </div>
          {/if}
          {title}
        </div>
      </div>

      <div slot="content" class="options-container ui-modal-body {contentClass}">
        {#each options as option (option)}
          <div
            class="container-option"
            style={option.style}
            on:click|preventDefault|stopPropagation={async () => {
              window.localStorage.setItem('mobileMenuPreviousPath', window.location.href);
              window.localStorage.setItem('mobileMenuPage', option.key);
              await option.fn(option, refresh);
              hideOptions();
            }}>
            {#if option.image}
              <div style="display: flex" class="container-option-image">
                {@html option.image}
              </div>
            {/if}
            <div class="container-option-name" style={option.containerNameStyle}>
              {#if option.label === 'line'}
                <div style="border-bottom: 1px solid #7f7f7f; opacity: 0.08; width: 100%;" />
              {:else}
                {@html option.label}
              {/if}
            </div>
            {#if option.showRedDot && option.showRedDot()}
              <div class="navigation-red-dot" style="position: relative; margin-left: 15px;" />
            {/if}
          </div>
        {/each}
      </div>
    </Modal>
  </div>
{/if}
